export default {
  "content": "<path d=\"M11 23.17V15H3.08L13 .83V9h7.92L11 23.17zM6.92 13H13v3.83L17.08 11H11V7.17L6.92 13z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};